import type { IconData } from '@stacksjs/iconify-core'

export const businessProductsWalletMoney: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.47 15.235h-1.52v-4.57h-1.52v4.57h-3.05v1.53h-1.52v3.04h1.52v1.53h3.05v6.09h1.52v-6.09h1.52v-1.53H32v-3.04h-1.53Zm-3.04 3.05H25.9v-1.52h1.53Zm-1.53 9.14h1.53v1.53H25.9Zm0-18.28h1.53v1.52H25.9ZM3.05 28.955H25.9v1.52H3.05Zm16.76-25.91h3.05v1.53h-3.05Zm-3.05 1.53h3.05v1.52h-3.05Zm-1.52-1.53h1.52v1.53h-1.52Zm-3.05-1.52h3.05v1.52h-3.05Zm-3.05 1.52h3.05v1.53H9.14Zm-3.05 1.53h3.05v1.52H6.09Zm0 6.09h1.53v16.76H6.09Z\"/><path fill=\"currentColor\" d=\"M25.9 9.145v-1.53h-1.52v-3.04h-1.52v3.04h-6.1v-1.52h-1.52v1.52H6.09v-1.52H4.57v1.52H3.05v1.53zM1.52 27.425h1.53v1.53H1.52Zm0-18.28h1.53v1.52H1.52ZM0 10.665h1.52v16.76H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default businessProductsWalletMoney
